import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { teamFitmentLoading: true, data: '', error: false };

export function teamFitmentReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_TEAM_FITMENT_DATA:
            return {
                teamFitmentLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_TEAM_FITMENT_DATA:
            return {
                teamFitmentLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_TEAM_FITMENT_DATA:
            return {
                teamFitmentLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/teamFitment.reducer.js